import {Injectable} from "@angular/core";
import {DxComboDatasource} from "../../../dx-forms/domain/combo/dx-combo-datasource";
import {DxNciService} from "../../../dx-nci-core/services/dx-nci.service";
import {Observable} from "rxjs";
import {DxComboElementDataProvider} from "../../../dx-forms/domain/combo/dx-combo-element-data-provider";
import {PitNciComboElement} from "./pit-nci-combo-element";
import {fromPromise} from "rxjs/internal-compatibility";

@Injectable()
export class PitNciComboDatasource implements DxComboDatasource {
  constructor(private _nciService: DxNciService) {}

   fetchElements(filter?: Map<string, Object>, sorts?: Map<string, string>): Observable<DxComboElementDataProvider[]> {
    // Идент справочника можно пробрасывать через фильтры
    // Сами фильтры можно описывать в опциях комбика.
    // Либо сформулировать како-то более явный механизм.
    const dictIdent: string = <string> filter.get('DICT_IDENT');
    const promise = new Promise<DxComboElementDataProvider[]>((resolve, reject) => {
      this._nciService
        .fetchDictionary(dictIdent)
        .subscribe(dictionary => {
          const elements: DxComboElementDataProvider[] = [];
          dictionary.elements.forEach(item => elements.push(new PitNciComboElement(item)));
          resolve(elements);
        }, error => {
          reject(error);
        });
    });
    return fromPromise<DxComboElementDataProvider[]>(promise);
  }
}
